var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftTriangleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7083153B-6A7D-4CBE-ADA8-8BE3F7FEF279") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-76.000000, -1507.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(76.000000, 1506.350000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22499943,3.9131573 L8.54568801,8.46125054 C8.92607384,8.86165667 8.90984417,9.49461361 8.50943804,9.87499943 C8.32358846,10.0515565 8.07703302,10.15 7.82068858,10.15 L-0.820688578,10.15 C-1.37297333,10.15 -1.82068858,9.70228475 -1.82068858,9.15 C-1.82068858,8.89365556 -1.72224511,8.64710012 -1.54568801,8.46125054 L2.77500057,3.9131573 C3.15538639,3.51275117 3.78834333,3.4965215 4.18874946,3.87690733 C4.20114058,3.88867889 4.21322787,3.90076618 4.22499943,3.9131573 Z",
    id: "Triangle",
    transform: "translate(3.500000, 6.650000) scale(-1, 1) rotate(90.000000) translate(-3.500000, -6.650000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTriangleIcon);
export default __webpack_public_path__ + "static/media/left-triangle-icon.b1611ff372de7a29ed87c5d367bffe58.svg";
export { ForwardRef as ReactComponent };